
import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white p-6 mt-auto">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <img 
              src="/lovable-uploads/39686db0-4967-4556-a4f9-65cbf5776672.png" 
              alt="Logo" 
              className="h-10 w-auto mr-3" 
            />
          </div>
          
          <div className="text-sm text-gray-300">
            &copy; {year} Todos os direitos reservados
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-700 text-sm text-center text-gray-400">
          Desenvolvido para gerenciamento sustentável
        </div>
      </div>
    </footer>
  );
};

export default Footer;
